// GENERATED by tools/audio/generate-wind-audio-catalog.mjs from tools/probes/wind_audio_catalog.php — do not hand-edit.
// WindLevel item id (encounter_wind / a room's creation.ambience.wind) → the one approved wind bed. Every
// client plays the same file for the same band; 'Still' is absent on purpose (still = no wind).
export interface WindAudioEntry {
    windLevelId: string;
    windLevel: string;
    audioId: string;
    audioName: string;
    file: string;
}

export const WIND_AUDIO_CATALOG: ReadonlyArray<WindAudioEntry> = [
    { windLevelId: 'EC7ACDFA-A5FE-77B7-3451-C5C080DD71B5', windLevel: "Breeze", audioId: 'BBD774B0-E915-4830-75C8-1D1249AE785E', audioName: "Wind Breeze 01",
      file: 'https://cdn.fatetide.com/audio/amb/BBD774B0-E915-4830-75C8-1D1249AE785E.mp3' },
    { windLevelId: '9283858C-98CD-FA04-72FC-5D2B9166A9D8', windLevel: "Strong Wind", audioId: '75E65A49-F288-B089-BAB7-D84AEF54300E', audioName: "Wind Moderate 01",
      file: 'https://cdn.fatetide.com/audio/amb/75E65A49-F288-B089-BAB7-D84AEF54300E.mp3' },
    { windLevelId: '29D3FFBA-3DB6-15C1-F88C-B72CFADAE907', windLevel: "Gale", audioId: '0EA6FC28-D74A-DFF6-53E9-7A0340119D19', audioName: "Wind Gale 01",
      file: 'https://cdn.fatetide.com/audio/amb/0EA6FC28-D74A-DFF6-53E9-7A0340119D19.mp3' },
    { windLevelId: 'EBC4D926-EF60-DD81-248E-54F6F31F29E0', windLevel: "Storm Wind", audioId: '1B0DA916-EAC3-9D17-FF10-C15EEE88CEB6', audioName: "Wind Storm 01",
      file: 'https://cdn.fatetide.com/audio/amb/1B0DA916-EAC3-9D17-FF10-C15EEE88CEB6.mp3' },
];

export function windAudioFor(windLevelId: string | null | undefined): WindAudioEntry | null {
    const want = String(windLevelId ?? '').trim().toUpperCase();
    return want ? WIND_AUDIO_CATALOG.find(entry => entry.windLevelId === want) ?? null : null;
}
